var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pension-modal-suggestion-details"},[(_vm.isProposal)?_c('SuggestionProposal',{attrs:{"data-testid":"details-proposal"}}):_vm._e(),(_vm.isPortability)?_c('SuggestionPortability',{attrs:{"data-testid":"details-portability"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }